import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

class PasswordField extends Component {
  state = {
    showPassword: false,
  };

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  };

  getPassVisibiliyButtonText = () => {
    const { showPassword } = this.state;

    return showPassword ? (
      <div className="btn-eye-off-outline" />
    ) : (
      <div className="btn-eye-outline" />
    );
  };

  render() {
    const { showPassword } = this.state;
    const {
      showRecoveryLink,
      name,
      label,
      isLabelUpper = false,
      inputRef,
      value,
      ...rest
    } = this.props;

    const labelClass = !value && !isLabelUpper ? 'label' : 'label label-upper';

    return (
      <div className="input-append">
        <div className="input-with-toggle">
          <label htmlFor={name} className={labelClass}>
            {label}
          </label>
          <input
            ref={inputRef}
            type={showPassword ? 'text' : 'password'}
            name={name}
            id={name}
            value={value}
            {...rest}
          />
          <button
            type="button"
            className="password-visibility-button"
            onClick={this.togglePasswordVisibility}
          >
            {this.getPassVisibiliyButtonText()}
          </button>
        </div>
        {showRecoveryLink && (
          <Link to="/publisher/recovery" className="forgot-password-button">
            <FormattedMessage
              id="affiliate.auth.forgot_password"
              defaultMessage="Forgot password?"
            />
          </Link>
        )}
      </div>
    );
  }
}

export default PasswordField;
